import { getFullName } from '../account';
import { formatDate } from '../formatDate';

import { IKnowledgeAreaDetailsResponse } from 'services/knowledge-area/knowledge-area.interface';
import { IKnowledgeAreaDetails } from 'views/pages/KnowledgeArea/knowledge-area.interface';

function convertKnowledgeAreaToDetailsView(
  knowledgeAreaResponse: IKnowledgeAreaDetailsResponse,
): IKnowledgeAreaDetails {
  const {
    id,
    name,
    description,
    category,
    created,
    accountCreated,
    accountUpdated,
    updated,
    organization,
    levels,
  } = knowledgeAreaResponse;
  return {
    id,
    name,
    category: category.name,
    description,
    updatedDate: updated ? formatDate(updated) : formatDate(created),
    createdDate: formatDate(created!),
    accountUpdatedBy: accountUpdated
      ? getFullName(accountUpdated.firstName, accountUpdated.lastName)
      : getFullName(accountCreated.firstName, accountCreated.lastName),
    accountCreatedBy: getFullName(accountCreated.firstName, accountCreated.lastName),
    organization,
    levels,
  };
}

export { convertKnowledgeAreaToDetailsView };
